export default "__VITE_PUBLIC_ASSET__2041674f__"